import dashboardRoutes from "@/routers/dashboard"

import { createRouter, createWebHistory } from "vue-router"
import analyticsService from "@/services/analytics/analytics-service"

const router = createRouter({
  history: createWebHistory(),
  scrollBehavior() {
    return { left: 0, top: 0 }
  },
  routes: [...dashboardRoutes]
})

export function addWildcardRoute() {
  router.addRoute({
    path: "/:pathMatch(.*)*",
    redirect: { name: "login" }
  })
}

router.afterEach((to, from) => {
  analyticsService.pageViewed({
    name: to.name,
    path: to.path,
    from_name: from ? from.name : null,
    from_path: from ? from.path : null
  })
})

export default router
